// Vorschläge für das Feld „Krankenkasse“ im Personalfragebogen: gesetzliche Krankenkassen, die großen zuerst. Die Liste
// ist nur eine Hilfe beim Tippen, jede andere Kasse (oder „privat versichert“) lässt sich frei eintragen.
// Namen sind Eigennamen und werden nicht übersetzt.
export const KRANKENKASSEN: readonly string[] = [
  'Techniker Krankenkasse (TK)',
  'BARMER',
  'DAK-Gesundheit',
  'AOK Baden-Württemberg',
  'AOK Bayern',
  'AOK Bremen/Bremerhaven',
  'AOK Hessen',
  'AOK Niedersachsen',
  'AOK Nordost',
  'AOK NordWest',
  'AOK PLUS',
  'AOK Rheinland/Hamburg',
  'AOK Rheinland-Pfalz/Saarland',
  'AOK Sachsen-Anhalt',
  'IKK classic',
  'KKH Kaufmännische Krankenkasse',
  'hkk Krankenkasse',
  'HEK – Hanseatische Krankenkasse',
  'BIG direkt gesund',
  'IKK gesund plus',
  'IKK – Die Innovationskasse',
  'IKK Südwest',
  'Knappschaft',
  'Mobil Krankenkasse',
  'SBK Siemens-Betriebskrankenkasse',
  'VIACTIV Krankenkasse',
  'BKK firmus',
  'pronova BKK',
  'Audi BKK',
  'mkk – meine krankenkasse',
  'Bosch BKK',
  'BKK Linde',
  'Novitas BKK',
  'Salus BKK',
  'BKK24',
  'BKK Pfalz',
  'Bertelsmann BKK',
  'energie-BKK',
  'R+V BKK',
  'Mercedes-Benz BKK',
  'BMW BKK',
  'Debeka BKK',
  'Heimat Krankenkasse',
  'mhplus Krankenkasse',
  'Merck BKK',
  'SECURVITA BKK',
  'vivida bkk',
  'WMF BKK',
  'Continentale BKK',
  'Ernst & Young BKK',
  'BKK Akzo Nobel Bayern',
  'BKK Diakonie',
  'BKK Gildemeister Seidensticker',
  'BKK Herkules',
  'BKK ProVita',
  'BKK Werra-Meissner',
  'BKK Wirtschaft & Finanzen',
  'Landwirtschaftliche Krankenkasse (SVLFG)',
];
